// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/server.js';

import { paths } from '../generated/server';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('server', Original, paths);
